// extracted by mini-css-extract-plugin
module.exports = {"base":"TableBlock_base__SqCyj"};